import { useEffect, useState } from 'react';

import type { CuratorFeed, CuratorPost } from './';

const curatorFeedIds = {
  '620 Loft & Garden': '55a2bad7-bcd3-4ba3-85d7-89f9a3098f74',
  'Private Events': 'f28adeb7-ae0d-4248-a2ce-54ec5e10c9fa',
  'Rainbow Room': 'b50e36a9-a3e2-4d79-85d2-8087c93f9b99',
  'Rockefeller Center': '77468e08-3885-44d0-ae49-7c799739c3bf',
  'Top of the Rock': '07dc8a28-b2f5-4f34-a480-d76c1767e1c0',
};

export type CuratorFeedName = keyof typeof curatorFeedIds;

export interface UseCuratorOptions {
  feedName?: CuratorFeedName;
}

export const useCurator = ({
  feedName = 'Rockefeller Center',
}: UseCuratorOptions) => {
  const fetchCuratorPosts = async (): Promise<CuratorPost[]> => {
    const feedId =
      curatorFeedIds[feedName] ?? curatorFeedIds['Rockefeller Center'];
    const apiUrl = `https://api.curator.io/v1/feeds/${feedId}/posts/?api_key=${
      process.env.CURATOR_API_KEY ?? ''
    }`;
    try {
      const response = await fetch(apiUrl);

      if (!response.ok) {
        throw new Error(
          `curator api error: ${response.status} (${
            response.statusText
          }) -- ${await response.text()}`,
        );
      }

      const data: CuratorFeed = await response.json();
      return data.posts;
    } catch (error) {
      console.error(error);
      throw new Error('Failed to fetch curator posts');
    }
  };

  const [curatorPosts, setCuratorPosts] = useState<CuratorPost[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    fetchCuratorPosts()
      .then((posts) => {
        setCuratorPosts(posts);
        setIsLoading(false);
      })
      .catch((err) => {
        setError(err);
        setIsLoading(false);
      });
  }, [feedName]);

  return { data: curatorPosts, isLoading, error };
};
